<header class="header text-center" >
    <img src="assets/images/logo.png" alt="logo">
</header>

<section>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer language">
                    <img src="assets/images/steps.svg" alt="steps">
                    <h1>Hi {{ contentDetails.LA_Name }},</h1>
                    <p><small>Your Application Number is <br> {{ contentDetails.policyNumber }}.</small></p>
                    <strong>Please follow these steps to verify the details<br> regarding your application for insurance</strong>
                    <div class="row">
                        <div class="col-md-5 text-left offset-md-1">
                            <div class="media align-items-center">
                                <img src="assets/images/language.svg" alt="language">
                                <div class="media-body">
                                    <h5 class="mt-0">Language</h5>
                                    Select your preferred language
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 text-left">
                            <div class="media align-items-center">
                                <img src="assets/images/recording.svg" alt="recording">
                                <div class="media-body">
                                    <h5 class="mt-0">Recording</h5>
                                    Record your video
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 text-left offset-md-1">
                            <div class="media align-items-center">
                                <img src="assets/images/questions.svg" alt="questions">
                                <div class="media-body">
                                    <h5 class="mt-0">Questions</h5>
                                    Select “Yes”/”No” to confirm details of 
                                    the policy applied
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5 text-left">
                            <div class="media align-items-center">
                                <img src="assets/images/previw-submit.svg" alt="previw-submit">
                                <div class="media-body">
                                    <h5 class="mt-0">Preview and Submit</h5>
                                    Review and submit your details
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="dash-line">
                    <br>
                    <div class="row">
                        <div class="col-sm-11 offset-sm-1 text-left">
                            <div class="media">
                                <img src="assets/images/language1.svg" alt="language1">
                                <div class="media-body">
                                    <h5 class="mt-0">Choose your preferred language <br>to complete PIVC </h5>
                                </div>
                            </div>
                            <ul class="languageButtons row">
                                <li class="col-xl-2 col-md-3 col-sm-4 col-6" *ngFor="let language of langList | keyvalue">
                                    <button type="button" class="btn btn-outline-secondary"
                                    (click)="languageSelection(language.key)"
                                    [ngClass]="{'active': langButton === language.key}"
                                    >{{ language.value }}</button>
                                </li>
                            </ul>
                           
                        </div>
                    </div>
                    <button type="button" class="btn btn-lg" (click)="onSubmit()">Next</button>
                </div>
            </div>
        </div>
    </div>
</section>